import { Link } from "react-router-dom";
import { copyright, footerNavigationItems } from "@components/Footer/constant";
import type { NavigationItem } from "@components/Footer/types";
import cx from "classnames";

export default function FooterBottom(): React.ReactElement {
  return (
    <div className="w-full border-t py-4">
      <div className="flex justify-center py-2">
        <ul className="flex flex-wrap justify-center font-poppins text-white">
          {footerNavigationItems.map(
            (navigationItem?: Pick<NavigationItem, "link" | "label">) => {
              return navigationItem ? (
                <li key={navigationItem.link}>
                  <Link
                    to={navigationItem.link}
                    className={cx("px-2 uppercase", "xl:px-3")}
                    reloadDocument
                  >
                    {navigationItem.label}
                  </Link>
                </li>
              ) : null;
            }
          )}
        </ul>
      </div>
      <div className="mt-4 px-3 text-center font-poppins text-base text-gray-500">
        <p className="mb-6">{copyright.title}</p>
        <p className="mb-0">{copyright.content}</p>
      </div>
    </div>
  );
}
